import { RefObject, useCallback, useLayoutEffect, useState } from 'react';
import { useDebounceFunction } from 'shared/lib/debounce';

export const useElementSizes = (
  ref: RefObject<Element>,
  { excludeHeight = 0, excludeWidth = 0 } = {},
): { height: number; width: number } => {
  const [sizes, setSizes] = useState({ height: 0, width: 0 });
  const resizeTable = useCallback(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    const { width: nodeWidth, height: nodeHeight } = node.getBoundingClientRect();
    const height = nodeHeight - excludeHeight;
    const width = nodeWidth - excludeWidth;
    setSizes({ height, width });
  }, [excludeHeight, excludeWidth, ref]);

  const debouncedResizeTable = useDebounceFunction(resizeTable, 100);

  useLayoutEffect(() => {
    debouncedResizeTable();
    window.addEventListener('resize', debouncedResizeTable);

    return () => {
      window.removeEventListener('resize', debouncedResizeTable);
    };
  }, [debouncedResizeTable]);

  return sizes;
};
